/** The id of the main region of every page. The skip link targets it. */
export const MAIN_ID = 'main'
